import React, {useState, useEffect} from 'react'
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import { CardActions } from '@mui/material';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import { Link as RouterLink } from 'react-router-dom';
import { Link } from '@mui/material';
import Divider from '@mui/material/Divider';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import { Button } from '@mui/material';
import { useMutation } from "react-query";
import apiClient from '../../request/http-common';
import CircularProgress from '@mui/material/CircularProgress';
import { useDispatch } from 'react-redux';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useSelector } from 'react-redux';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useQuery } from 'react-query';
import Avatar from '@mui/material/Avatar';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CurrencyBitcoinIcon from '@mui/icons-material/CurrencyBitcoin';
import IconButton from '@mui/material/IconButton';
import usePortfolioBalance from '../../hooks/usePortfolioBalance';



const SwapCoin = () => {
      
  const coins = useSelector((state) => state.coins.coins);
  const {
    coinRates,
    formatUsd,
    formatCryptoAmount,
    getCoinUnits,
    getCoinUsd,
    getPriceUsd,
  } = usePortfolioBalance();
  const formatPrice = formatUsd;

  const [swapMode, setSwapMode] = useState('usd'); // 'usd' or 'crypto'
  const [estimatedAmount, setEstimatedAmount] = useState(0);

    const initwallet = {
        amount : ''	,
        from_coin : ''	,
        to_coin : ''	,
        
    }
    
    
    const [error, setErros] = useState('');
    const [walletForm, setwalletForm] = useState(initwallet);

    const onChange = (e) => {
      const newForm = { ...walletForm, [e.target.name]: e.target.value };
      setwalletForm(newForm);
      
      // Calculate estimated amount when amount, from_coin, or to_coin changes
      if (e.target.name === 'amount' || e.target.name === 'from_coin' || e.target.name === 'to_coin') {
        calculateEstimatedAmount(newForm);
      }
    };

    // Calculate estimated conversion amount
    const calculateEstimatedAmount = (form = walletForm) => {
      if (!form.amount || !form.from_coin || !form.to_coin || !coinRates.length) {
        setEstimatedAmount(0);
        return;
      }

      const fromCoin = coinRates.find(c => c.symbol === form.from_coin);
      const toCoin = coinRates.find(c => c.symbol === form.to_coin);

      if (!fromCoin || !toCoin) {
        setEstimatedAmount(0);
        return;
      }

      let amountInUSD = 0;
      
      if (swapMode === 'usd') {
        // Amount is already in USD
        amountInUSD = parseFloat(form.amount) || 0;
      } else {
        // Amount is in from_coin units, convert to USD
        amountInUSD = (parseFloat(form.amount) || 0) * parseFloat(fromCoin.priceUsd);
      }

      // Convert USD to to_coin
      const estimated = amountInUSD / parseFloat(toCoin.priceUsd);
      setEstimatedAmount(estimated);
    };

    // Handle swap mode change
    const handleSwapModeChange = (mode) => {
      setSwapMode(mode);
      // Recalculate when mode changes
      setTimeout(() => calculateEstimatedAmount(), 100);
    };

    // Handle swap direction (reverse from and to)
    const handleSwapDirection = () => {
      const newForm = {
        ...walletForm,
        from_coin: walletForm.to_coin,
        to_coin: walletForm.from_coin
      };
      setwalletForm(newForm);
      calculateEstimatedAmount(newForm);
    };

    // Handle MAX button click
    const handleMaxClick = () => {
      if (walletForm.from_coin) {
        const units = getCoinUnits(walletForm.from_coin);
        if (swapMode === 'usd') {
          setwalletForm({ ...walletForm, amount: getCoinUsd(walletForm.from_coin).toFixed(2) });
        } else {
          setwalletForm({ ...walletForm, amount: units.toFixed(8) });
        }
      }
    };

    const getCoinPrice = (symbol) => getPriceUsd(symbol);

    // Recalculate when swapMode or coinRates change
    useEffect(() => {
      if (walletForm.amount && walletForm.from_coin && walletForm.to_coin) {
        calculateEstimatedAmount(walletForm);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [swapMode, coinRates]);


    const { isLoading: isSendingRequest, mutate: postwallet } = useMutation(

        async () => {
          let amountCrypto = parseFloat(walletForm.amount) || 0;

          if (swapMode === 'usd' && walletForm.from_coin) {
            const price = getPriceUsd(walletForm.from_coin);
            if (price > 0) {
              amountCrypto = amountCrypto / price;
            }
          }

          return await apiClient.post(`/api/swap-coin`, {
            amount: amountCrypto,
            from_coin: walletForm.from_coin,
            to_coin: walletForm.to_coin,
          });
        },
        {
          onSuccess: (res) => {
            localStorage.setItem('notification', JSON.stringify({message : `${res.data.message}`, 'type': 'success' }));
            const event = new Event('newMessage');
            window.dispatchEvent(event);
            const event2 = new Event('processed');
            window.dispatchEvent(event2);
            // Reset form after successful swap
            setwalletForm(initwallet);
            setEstimatedAmount(0);
          },
          onError: (err) => {   
            if (err.response?.data.length) {
              let myerror = err.response?.data || err;         
          setErros(myerror.errors) 

          
          }else{
              let errorMessage = err.response?.data.message || err ;
              localStorage.setItem('notification', JSON.stringify({message : `${errorMessage}`, 'type': 'error' }));
              const event = new Event('newMessage');
              window.dispatchEvent(event);
          }  
          },
        }
      );
      const onSubmit = () =>{
        const event3 = new Event('processing');
        window.dispatchEvent(event3);
        postwallet();
      } 


  const getCoinIcon = (symbol) => {
    if (!symbol) return null;
    return `https://assets.coincap.io/assets/icons/${symbol.toLowerCase()}@2x.png`;
  };

  return (
    <div style={{marginTop: '70px', backgroundColor: '#1a1a1a', minHeight: '100vh', paddingBottom: '100px'}}>
        <Grid container px={2} pt={4} pb={4} rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid item xs={12} md={12}>
                {/* Title Section */}
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
                  <SwapVertIcon sx={{ color: '#f8a500', mr: 1, fontSize: 28 }} />
                  <Typography sx={{ fontWeight: 'bold', fontSize: 32, color: '#fff' }}>
                    Swap
                  </Typography>
                </Box>
                
                <Typography sx={{ textAlign: 'center', fontSize: 16, color: '#888', mb: 3 }}>
                  Exchange your crypto instantly
                </Typography>

                {/* Swap Mode Toggle */}
                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3, gap: 1 }}>
                  <Button
                    variant={swapMode === 'usd' ? 'contained' : 'outlined'}
                    onClick={() => handleSwapModeChange('usd')}
                    startIcon={<AttachMoneyIcon />}
                    sx={{
                      borderRadius: '12px',
                      textTransform: 'none',
                      backgroundColor: swapMode === 'usd' ? '#f8a500' : 'transparent',
                      color: swapMode === 'usd' ? '#fff' : '#888',
                      borderColor: swapMode === 'usd' ? '#f8a500' : '#333',
                      '&:hover': {
                        backgroundColor: swapMode === 'usd' ? '#e69500' : '#333',
                        borderColor: '#f8a500'
                      }
                    }}
                  >
                    $ USD
                  </Button>
                  <Button
                    variant={swapMode === 'crypto' ? 'contained' : 'outlined'}
                    onClick={() => handleSwapModeChange('crypto')}
                    startIcon={<CurrencyBitcoinIcon />}
                    sx={{
                      borderRadius: '12px',
                      textTransform: 'none',
                      backgroundColor: swapMode === 'crypto' ? '#f8a500' : 'transparent',
                      color: swapMode === 'crypto' ? '#fff' : '#888',
                      borderColor: swapMode === 'crypto' ? '#f8a500' : '#333',
                      '&:hover': {
                        backgroundColor: swapMode === 'crypto' ? '#e69500' : '#333',
                        borderColor: '#f8a500'
                      }
                    }}
                  >
                    ₿ Crypto
                  </Button>
                </Box>

                {/* From Card */}
                <Card sx={{ 
                  backgroundColor: '#2a2a2a', 
                  borderRadius: '16px', 
                  mb: 2,
                  border: '1px solid #333'
                }}>
                  <CardContent sx={{ pb: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                      <Typography sx={{ color: '#888', fontSize: 14, fontWeight: 500 }}>
                        From {swapMode === 'usd' ? '(USD)' : ''}
                      </Typography>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography sx={{ color: '#888', fontSize: 14 }}>
                          Bal: {walletForm.from_coin ? (
                            swapMode === 'usd' ? 
                              formatPrice(getCoinUsd(walletForm.from_coin)) :
                              formatCryptoAmount(getCoinUnits(walletForm.from_coin)) + ' ' + walletForm.from_coin
                          ) : formatPrice(0)}
                        </Typography>
                        {walletForm.from_coin && (
                          <Button
                            size="small"
                            onClick={handleMaxClick}
                            sx={{
                              backgroundColor: '#f8a500',
                              color: '#fff',
                              borderRadius: '6px',
                              minWidth: '50px',
                              fontSize: '12px',
                              textTransform: 'none',
                              '&:hover': {
                                backgroundColor: '#e69500'
                              }
                            }}
                          >
                            MAX
                          </Button>
                        )}
                      </Box>
                    </Box>

                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                      {/* Coin Selector */}
                      <FormControl sx={{ minWidth: 120 }}>
                        <Select
                          value={walletForm.from_coin || ''}
                          onChange={onChange}
                          name="from_coin"
                          displayEmpty
                          sx={{
                            backgroundColor: '#1a1a1a',
                            color: '#fff',
                            borderRadius: '12px',
                            '& .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#333'
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#555'
                            },
                            '& .MuiSvgIcon-root': {
                              color: '#fff'
                            }
                          }}
                          renderValue={(selected) => {
                            if (!selected) {
                              return (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  <Typography sx={{ color: '#888' }}>Select</Typography>
                                </Box>
                              );
                            }
                            const coin = coinRates.find(c => c.symbol === selected);
                            return (
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                {coin && (
                                  <Avatar 
                                    src={getCoinIcon(selected)} 
                                    sx={{ width: 24, height: 24 }}
                                  />
                                )}
                                <Typography>{selected}</Typography>
                              </Box>
                            );
                          }}
                        >
                          {coinRates.length > 0 && 
                            coinRates.map((coin) => (
                              <MenuItem key={coin.symbol} value={coin.symbol}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  <Avatar 
                                    src={getCoinIcon(coin.symbol)} 
                                    sx={{ width: 24, height: 24 }}
                                  />
                                  <Typography>{coin.symbol}</Typography>
                                </Box>
                              </MenuItem>
                            ))
                          }
                        </Select>
                      </FormControl>

                      {/* Amount Input */}
                      <Box sx={{ flex: 1 }}>
                        <OutlinedInput
                          value={walletForm.amount || ''}
                          onChange={onChange}
                          name="amount"
                          type="number"
                          placeholder="0.00"
                          fullWidth
                          error={error !== '' && error.amount}
                          sx={{
                            backgroundColor: '#1a1a1a',
                            color: '#fff',
                            borderRadius: '12px',
                            fontSize: '20px',
                            '& .MuiOutlinedInput-notchedOutline': {
                              borderColor: error !== '' && error.amount ? '#f44336' : '#333'
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                              borderColor: error !== '' && error.amount ? '#f44336' : '#555'
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#f8a500'
                            },
                            input: {
                              color: '#fff',
                              '&::placeholder': {
                                color: '#888'
                              }
                            }
                          }}
                        />
                        {error !== '' && error.amount && (
                          <Typography color='error' sx={{ fontSize: 12, mt: 0.5 }}>
                            {error.amount}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                    {error !== '' && error.from_coin && (
                      <Typography color='error' sx={{ fontSize: 12, mt: 1 }}>
                        {error.from_coin}
                      </Typography>
                    )}
                  </CardContent>
                </Card>

                {/* Swap Direction Button */}
                <Box sx={{ display: 'flex', justifyContent: 'center', my: 1 }}>
                  <IconButton
                    onClick={handleSwapDirection}
                    sx={{
                      backgroundColor: '#f8a500',
                      color: '#fff',
                      width: 48,
                      height: 48,
                      '&:hover': {
                        backgroundColor: '#e69500'
                      }
                    }}
                  >
                    <SwapVertIcon />
                  </IconButton>
                </Box>

                {/* To Card */}
                <Card sx={{ 
                  backgroundColor: '#2a2a2a', 
                  borderRadius: '16px', 
                  mb: 3,
                  border: '1px solid #333'
                }}>
                  <CardContent sx={{ pb: 2 }}>
                    <Typography sx={{ color: '#888', fontSize: 14, fontWeight: 500, mb: 2 }}>
                      To (Estimated)
                    </Typography>

                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                      {/* Coin Selector */}
                      <FormControl sx={{ minWidth: 120 }}>
                        <Select
                          value={walletForm.to_coin || ''}
                          onChange={onChange}
                          name="to_coin"
                          displayEmpty
                          sx={{
                            backgroundColor: '#1a1a1a',
                            color: '#fff',
                            borderRadius: '12px',
                            '& .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#333'
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#555'
                            },
                            '& .MuiSvgIcon-root': {
                              color: '#fff'
                            }
                          }}
                          renderValue={(selected) => {
                            if (!selected) {
                              return (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  <Typography sx={{ color: '#888' }}>Select</Typography>
                                </Box>
                              );
                            }
                            const coin = coinRates.find(c => c.symbol === selected);
                            return (
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                {coin && (
                                  <Avatar 
                                    src={getCoinIcon(selected)} 
                                    sx={{ width: 24, height: 24 }}
                                  />
                                )}
                                <Typography>{selected}</Typography>
                              </Box>
                            );
                          }}
                        >
                          {coinRates.length > 0 && 
                            coinRates.map((coin) => (
                              <MenuItem key={coin.symbol} value={coin.symbol}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  <Avatar 
                                    src={getCoinIcon(coin.symbol)} 
                                    sx={{ width: 24, height: 24 }}
                                  />
                                  <Typography>{coin.symbol}</Typography>
                                </Box>
                              </MenuItem>
                            ))
                          }
                        </Select>
                      </FormControl>

                      {/* Estimated Amount Display */}
                      <Box sx={{ flex: 1 }}>
                        <OutlinedInput
                          value={estimatedAmount > 0 ? formatCryptoAmount(estimatedAmount) : '0.00'}
                          disabled
                          fullWidth
                          sx={{
                            backgroundColor: '#1a1a1a',
                            color: '#fff',
                            borderRadius: '12px',
                            fontSize: '20px',
                            '& .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#333'
                            },
                            '&.Mui-disabled': {
                              color: '#fff',
                              WebkitTextFillColor: '#fff'
                            },
                            input: {
                              color: '#fff'
                            }
                          }}
                        />
                      </Box>
                    </Box>
                    {error !== '' && error.to_coin && (
                      <Typography color='error' sx={{ fontSize: 12, mt: 1 }}>
                        {error.to_coin}
                      </Typography>
                    )}
                  </CardContent>
                </Card>

                {/* Swap Now Button */}
                <Button
                  onClick={onSubmit}
                  fullWidth
                  size="large"
                  variant="contained"
                  disabled={isSendingRequest}
                  sx={{
                    backgroundColor: '#f8a500',
                    color: '#fff',
                    borderRadius: '12px',
                    py: 1.5,
                    fontSize: '16px',
                    fontWeight: 'bold',
                    textTransform: 'none',
                    '&:hover': {
                      backgroundColor: '#e69500'
                    },
                    '&:disabled': {
                      backgroundColor: '#555',
                      color: '#888'
                    }
                  }}
                >
                  {isSendingRequest ? 'Swapping...' : 'Swap Now'}
                </Button>
            </Grid>
        </Grid>
    </div>
  )
}

export default SwapCoin
